import { useTranslation } from 'react-i18next'
import { FormItem } from '../../components/form-item'
import { Input } from 'antd'
import React from 'react'

export function BillingFormElements() {
    const { t } = useTranslation()

    // Checked in the browser, so empty fields show at once with the terms and the card instead of after them.
    const required = [{ required: true, message: t('This field is required.') }]

    return (
        <>
            <FormItem label={t('Country')}>
                <Input
                    value={t('Netherlands')}
                    disabled
                />
            </FormItem>
            <FormItem
                label={t('Company name')}
                name="name"
                rules={required}
                required
            >
                <Input placeholder="Evaa B.V." />
            </FormItem>
            <FormItem
                label={t('VAT number')}
                name="vatNumber"
            >
                <Input placeholder="NL123456789B01" />
            </FormItem>
            <FormItem
                label={t('Email')}
                name="email"
                rules={required}
                required
            >
                <Input placeholder="hi@evaa.chat" />
            </FormItem>
            <FormItem
                required
                label={t('Address')}
                name="address"
                rules={required}
            >
                <Input placeholder="Hoofdstraat 29B" />
            </FormItem>
            <FormItem
                required
                label={t('Postal code')}
                name="postalCode"
                rules={required}
            >
                <Input placeholder="1232 AA" />
            </FormItem>
            <FormItem
                required
                label={t('City')}
                name="city"
                rules={required}
            >
                <Input placeholder="Utrecht" />
            </FormItem>
        </>
    )
}
